const initState = {
  managers: [],
  lastDocument: null,
  hasMoreDocument: true,
  managerTotalEarnings: {},
  // ******talking******
  talkingEarnings: [],
  talkingLastDocument: null,
  talkingHasMoreDocument: true,
  // *******seasonal******
  seasonalEarnings: [],
  seasonalLastDocument: null,
  seasonalHasMoreDocument: true,
  // *********momento********
  momentoEarnings: [],
  momentoLastDocument: null,
  momentoHasMoreDocument: true,
  // ********group chat******
  groupChatEarnings: [],
  groupChatLastDocument: null,
  groupChatHasMoreDocument: true,
};

const managerReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_ALL_MANAGERS":
      return {
        ...state,
        managers: action.payload.data,
        lastDocument: action.payload.lastDocument,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    case "GET_ALL_MANAGERS_LOAD_MORE":
      return {
        ...state,
        managers: [...state.managers, ...action.payload.data],
        lastDocument: action.payload.lastDocument,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    case "GET_MANAGER_EARNINGS":
      return {
        ...state,
        managerTotalEarnings: action.payload,
      };
    //******* seasonal*******
    case "SEASONAL_MANAGER_EARNING":
      return {
        ...state,
        seasonalEarnings: action.payload.data,
        seasonalLastDocument: action.payload.lastDocument,
        seasonalHasMoreDocument: action.payload.hasMoreDocument,
      };
    case "SEASONAL_MANAGER_EARNING_LOAD_MORE":
      return {
        ...state,
        seasonalEarnings: [...state.seasonalEarnings, ...action.payload.data],
        seasonalLastDocument: action.payload.lastDocument,
        seasonalHasMoreDocument: action.payload.hasMoreDocument,
      };
    // ********talking*****
    case "TALKING_MANAGER_EARNING":
      return {
        ...state,
        talkingEarnings: action.payload.data,
        talkingLastDocument: action.payload.lastDocument,
        talkingHasMoreDocument: action.payload.hasMoreDocument,
      };
    case "TALKING_MANAGER_EARNING_LOAD_MORE":
      return {
        ...state,
        talkingEarnings: [...state.talkingEarnings, ...action.payload.data],
        talkingLastDocument: action.payload.lastDocument,
        talkingHasMoreDocument: action.payload.hasMoreDocument,
      };
    // ********momento******
    case "MOMENTO_MANAGER_EARNING":
      return {
        ...state,
        momentoEarnings: action.payload.data,
        momentoLastDocument: action.payload.lastDocument,
        momentoHasMoreDocument: action.payload.hasMoreDocument,
      };
    case "MOMENTO_MANAGER_EARNING_LOAD_MORE":
      return {
        ...state,
        momentoEarnings: [...state.momentoEarnings, ...action.payload.data],
        momentoLastDocument: action.payload.lastDocument,
        momentoHasMoreDocument: action.payload.hasMoreDocument,
      };
    //  ******group chat******
    case "GROUP_CHAT_MANAGER_EARNING":
      return {
        ...state,
        groupChatEarnings: action.payload.data,
        groupChatLastDocument: action.payload.lastDocument,
        groupChatHasMoreDocument: action.payload.hasMoreDocument,
      };
    case "GROUP_CHAT_MANAGER_EARNING_LOAD_MORE":
      return {
        ...state,
        groupChatEarnings: [...state.groupChatEarnings, ...action.payload.data],
        groupChatLastDocument: action.payload.lastDocument,
        groupChatHasMoreDocument: action.payload.hasMoreDocument,
      };
    default:
      return {
        ...state,
      };
  }
};
export default managerReducer;
